import { render, staticRenderFns } from "./Abbinamenti.vue?vue&type=template&id=6da37338"
import script from "./Abbinamenti.vue?vue&type=script&lang=js"
export * from "./Abbinamenti.vue?vue&type=script&lang=js"
import style0 from "./Abbinamenti.vue?vue&type=style&index=0&id=6da37338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports